import { useEffect, useState } from "react";
import { logger } from "@fidget/common/utils";
import { config } from "@fidget/common/config/config";

export interface Props {
  onDelete(): Promise<void>;
  onTimeoutPassed(): void;
  onError(err: Error): void;
}
export enum DeletingState {
  Pristine,
  AwaitingAction,
  DisplayingConfirmation
}
export const useDeleteConfirmationState = ({ onDelete, onError, onTimeoutPassed }: Props) => {
  const [state, setState] = useState(DeletingState.Pristine);
  const [timer, setTimer] = useState<number>();

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  const onRemove = async () => {
    try {
      await onDelete();
      setState(DeletingState.DisplayingConfirmation);
      setTimer(
        window.setTimeout(onTimeoutPassed, config.services.times.timeoutSettingsDeleteConfirmationMs)
      );
    } catch (e) {
      logger.error({ message: "Couldn't delete entry", error: e });
      onError(e as Error);
    }
  };

  return { state, setState, onRemove };
};
